import { useDetailsForm } from "../../Hooks/Features/WelcomeKit/useDetailsForm";
import { dateConvert, renderField } from "../../utils/Helper";
import FormTable from "./FormTable";

function DetailsForm({ onPrev, onNext, label, data, readOnly }) {
    const { fieldData, pageTitle, formValues, handleChange, handleNext, formErrors, handleSave } = useDetailsForm({ label, onNext, data });

    return (
        <div className="">
            {
                pageTitle && <h4 className="p-2">{pageTitle}</h4>
            }
            <form>
                {Object.entries(fieldData).map(([section, fields]) => (
                    <div key={section} className="my-2">
                        {
                            !fields?.isFormTable && <h4 className={`p-2 ${readOnly ? " my-1" : "my-2"}`} style={{ background: "#f2f2f2" }}>{section}</h4>
                        }
                        {fields?.otherText && <div className='d-flex justify-content-between'>
                            <span><b>Employee Name: </b>{data?.employee?.user_display_name}</span>
                            <span><b>Employee Id: </b>{data?.employee?.employee_id}</span>
                            <span><b>Joining Date: </b> {dateConvert(data?.employee?.joining_date, "day-mon-year")}</span>
                        </div>}
                        {fields?.subText && <h5>{fields?.subText}</h5>}
                        {
                            fields?.key === "employee_contact_details" && !readOnly ?
                                <div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="row">
                                                {
                                                    fields.inputs?.slice(0, 4)?.map((value, index) => {
                                                        if (value.depand && !formValues[section]?.[value.depand]) return null;
                                                        return renderField(value, index,
                                                            e => handleChange(section, e),
                                                            formValues[section] || {},
                                                            formErrors[section] || {},
                                                            null, null, null, readOnly
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="row">
                                                {
                                                    fields.inputs?.slice(4, 8)?.map((value, index) => {
                                                        if (value.depand && !formValues[section]?.[value.depand]) return null;
                                                        return renderField(value, index,
                                                            e => handleChange(section, e),
                                                            formValues[section] || {},
                                                            formErrors[section] || {},
                                                            null, null, null, readOnly
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div> : <div className="row">
                                    {fields?.isFormTable ? (
                                        <FormTable
                                            onPrev={onPrev}
                                            onNext={onNext}
                                            label={label}
                                            fieldsDetails={{ [section]: fields }}
                                            data={data}
                                            familyList={[]}
                                            readOnly={readOnly}
                                        />
                                    ) : readOnly ? (
                                        <div className="table-responsive ">
                                            <table className="table table-bordered mb-0" style={{
                                                fontSize: '10pt !important',
                                                lineHeight: '1.3 !important',
                                                pageBreakInside: 'avoid'
                                            }}>
                                                <tbody>
                                                    {fields.inputs?.map((value, index) => {
                                                        if (value.depand && !formValues[section]?.[value.depand]) return null;
                                                        if (value?.type === "button" || value.type === "file") return null;

                                                        const fieldValue = formValues[section]?.[value.name] || '';
                                                        return (
                                                            <tr key={index} style={{ pageBreakInside: 'avoid' }}>
                                                                <td className="fw-semibold py-1" style={{
                                                                    width: '50%',
                                                                    borderColor: '#ddd',
                                                                    lineHeight: "1rem"
                                                                }}>
                                                                    {value.label}
                                                                </td>
                                                                <td className="py-1" style={{
                                                                    borderColor: '#ddd',
                                                                    wordBreak: 'break-word'
                                                                }}>
                                                                    { value?.type === "date" ?  dateConvert(fieldValue,"day-mon-year"): typeof fieldValue === "boolean" ? fieldValue ? "Yes" : "No" : fieldValue}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        fields.inputs?.map((value, index) => {
                                            if (value.depand && !formValues[section]?.[value.depand]) return null;
                                            return value?.type !== "button" ? (
                                                renderField(value, index,
                                                    e => handleChange(section, e),
                                                    formValues[section] || {},
                                                    formErrors[section] || {},
                                                    null, null, null, readOnly
                                                )
                                            ) : (
                                                <div key={index} className={`${value?.col} w100 d-flex justify-content-end`}>
                                                    <button className='btn-primary' onClick={(e) => handleSave(e, section, value?.optionKey)}>
                                                        {value?.label}
                                                    </button>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                        }

                    </div>
                ))}
                {
                    !readOnly && <div className='d-flex gap-2 justify-content-end position-fixed w90 bottom-0 end-0 px-4 pb-2 bg-white'>
                        <button className='btn-default' onClick={onPrev}>Previous</button>
                        <button className='btn-primary' onClick={handleNext}>Proceed</button>
                    </div>
                }

            </form>
        </div>
    );
}
export default DetailsForm
